// Import the dependencies and necessary modules

import 'babel-polyfill'
import 'whatwg-fetch'

import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';

import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import aws_exports from './aws-exports';
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/style.css'


import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faCaretUp, 
  faCaretDown, 
  faCheck,
  faMinusSquare, 
  faPaperclip, 
  faTrashAlt, 
  faShareAlt, 
  faArchive, 
  faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCaretUp, 
  faCaretDown,
  faCheck, 
  faMinusSquare, 
  faPaperclip,
  faTrashAlt,
  faShareAlt,
  faArchive,
  faUpload)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import store from './store'
import { API, graphqlOperation } from 'aws-amplify' 
import { createErrorLog } from '@/graphql/mutations'

Amplify.configure(aws_exports);

// Globally register the components for project-wide use
Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(BootstrapVue);
Vue.use(Vuex);


async function logNav(dest) {
  try {

    if (dest) {
      let input = {
        func: "navigate",
        fullPath: dest.fullPath,
        name: dest.name,
        params: dest.params,
        date: new Date()
      }
      await API.graphql(graphqlOperation(createErrorLog, {input}))
    }
  } catch(err) {
    // empty
    console.log("error logging nav", err, dest)
  }
}
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  logNav(to);
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
